import { fetchAuthSession, signOut } from "aws-amplify/auth";
import type { PermissionToken } from "@/common/permissionHandler";

export const getAuthToken = async (): Promise<string> => {
  const session = await fetchAuthSession();
  return session.tokens?.idToken?.toString() || "";
};

export const getUserHotelsPermissions = async (): Promise<string> => {
  const session = await fetchAuthSession();
  return (
    (session.tokens?.idToken?.payload["custom:permissions"] as string) || ""
  );
};

export const getParsedPermissions =
  async (): Promise<PermissionToken | null> => {
    const raw = await getUserHotelsPermissions();
    if (!raw) return null;
    try {
      return JSON.parse(raw) as PermissionToken;
    } catch {
      return null;
    }
  };

export const userSignOut = async () => {
  try {
    await signOut();
    sessionStorage.setItem("toastMessage", "You have been signed out");
  } catch (error: unknown) {
    const message = error instanceof Error ? error.message : "Sign out failed";
    sessionStorage.setItem("toastMessage", message);
  } finally {
    if (typeof window !== "undefined") {
      window.location.href = "/sign-in";
    }
  }
};
